<template>
  <nav class="nav">
    <ul>
      <li>
        <router-link :to="{name: 'collisionsIndex'}"><i class="material-icons">flare</i> <span>Collisions</span></router-link>
      </li>
      <li>
          <a class="nav-toggle" v-on:click="toggle($event)"><i class="material-icons">gavel</i> <span>City Council Districts</span><i class="material-icons nav-toggle-arrow">keyboard_arrow_right</i></a>
          <ul>
              <li><router-link :to="{name: 'cityCouncilDistricts'}"><span>List</span></router-link></li>
              <li><router-link :to="{name: 'cityCouncilDistrictRanksIndex'}"><span>Ranks</span></router-link></li>
          </ul>
      </li>
      <li>
          <a class="nav-toggle" v-on:click="toggle($event)"><i class="material-icons">nature_people</i> <span>Neighborhood</span><i class="material-icons nav-toggle-arrow">keyboard_arrow_right</i></a>
          <ul>
              <li><router-link :to="{name: 'neighborhoods'}"><span>List</span></router-link></li>
              <li><router-link :to="{name: 'neighborhoodRanksIndex'}"><span>Ranks</span></router-link></li>
          </ul>
      </li>
      <li>
          <a href="#" class="nav-toggle" v-on:click="toggle($event)"><i class="material-icons">info_outline</i> <span>About</span><i class="material-icons nav-toggle-arrow">keyboard_arrow_right</i></a>
          <ul>
              <li><a href="/blog/the-story"><span>The Story</span></a></li>
              <li><a href="/blog/the-data"><span>The Data</span></a></li>
              <li><a href="/blog/the-technology"><span>The Technology</span></a></li>
              <li><a href="/blog/media-coverage"><span>In The Media</span></a></li>
              <li><a href="/blog/todo"><span>To Do</span></a></li>
          </ul>
      </li>
      <li><a href="/blog"><i class="material-icons">library_books</i> <span>Blog</span></a></li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'navigation',
  methods: {
    toggle: function (event) {
      let app = document.getElementById('app')
      if (window.innerWidth > 960) {
        app.classList.remove('s-sidebar-toggled')
      } else {
        app.classList.add('s-sidebar-toggled')
      }

      let navToggles = document.getElementsByClassName('nav-toggle')

      for (let key in navToggles) {
        if (typeof navToggles[key].classList !== 'undefined') {
          if (event.target === navToggles[key]) {
            event.target.parentElement.classList.toggle('active')
          } else if (event.target.parentElement === navToggles[key]) {
            event.target.parentElement.parentElement.classList.toggle('active')
          } else {
            navToggles[key].parentElement.classList.remove('active')
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import "./src/sass/components/navigation.scss";
</style>



// WEBPACK FOOTER //
// Navigation.vue?629e2fba